






















































































































































import Vue from 'vue';
import {EventType} from '@/types/event-type';
import {EventApi} from '@/api/event-api';
import {StreamType} from '@/types/stream-type';
import {EventPublicType} from '@/types/event-public-type';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import {quillEditor} from 'vue-quill-editor';
import moment from 'moment';
import {Camera} from '@/types/camera-type';
import {CameraApi} from '@/api/camera-api';
import TicketCategoryList from '@/views/TicketCategoryList.vue';
import {InitiatorClass} from '@/types/InitiatorClass';
import ActionConfirmation from '@/components/ActionConfirmation.vue';
import Ticket from '@/views/Ticket.vue';
import {UserRole} from '@/types/user-role';
import {InitiatorApi} from '@/api/initiator-api';
import PicDateTime from '@/components/PicDateTime.vue';
import {TicketCategory} from '@/types/ticket-category';
import {TicketCategoryApi} from '@/api/category-api';
import {RoutsData} from '@/router/routs';
import {Channel} from '@/types/channel';
import {ChannelApi} from '@/api/channel-api';
import EventStatistics from '@/components/EventStatistics.vue';

let eventId: string;
export default Vue.extend({
  name: 'Event',
  components: {quillEditor, TicketCategoryList, ActionConfirmation, Ticket, PicDateTime, EventStatistics},
  created() {
    eventId = this.$route.params.eventId;
    this.getChannel();
    if (eventId) {
      this.getEvent(eventId);
      this.getCamera(eventId);
    }
    if (this.$store.state.user.role == UserRole.ADMIN) {
      InitiatorApi.getList().then(res => this.initiators = res.data);
    }
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: true
        },
        theme: 'snow'
      },
      event: new EventType(),
      streamTypes: StreamType,
      publicTypes: Object.keys(EventPublicType).map(i => ({text: i, value: (EventPublicType as any)[i]})),
      cameras: [] as Camera[],
      cameraType: {
        FLAT_VIDEO: [{text: 'Трансляция', value: 'FLAT'}, {text: 'Конференция', value: 'FLATTELEPRESENT'}],
        VR_VIDEO: ['VR360MONO', 'VR360STEREO', 'VR180MONO', 'VR180STEREO', 'VRTELEPRESENT']
      },
      channel: [] as Channel[],
      isShowConfirm: {show: false, action: () => null, actionData: null, text: ''},
      initiators: [] as InitiatorClass[],
      categories: [] as TicketCategory[],
      disableSave: false,
      eventStartError: false,
      eventEndError: false
    };
  },
  computed: {
    isSave(): boolean {
      return !!this.$route.params.eventId;
    },
    dateIntervalValidate(): boolean {
      if (!this.event.title) {
        return false;
      }

      return this.dateValidate();
    },
    initiatorForAdmin(): boolean {
      if (this.$store.state.user.role !== UserRole.ADMIN) {
        return true;
      }
      return !!(this.event.initiator && this.event.initiator.id);
    }
  },
  methods: {
    getEvent(id: string) {
      EventApi.getEvent(eventId as string).then((res: any) => {
        this.event = res.data;
        this.$store.commit('setInitiator', this.event.initiator);
      });

      TicketCategoryApi.getListByEvent(eventId).then(res => this.categories = res.data);
    },
    onClick() {
      if (!!eventId) {
        return this.edit();
      }
      return this.save();
    },
    validate() {
      if (!this.event.title) {
        this.$store.commit('setMessage', {show: true, text: 'Не заполнено поле название'});
        return false;
      }

      if (!this.dateValidate()) {
        this.$store.commit('setMessage', {
          show: true,
          text: 'Дата начала мероприятия не может быть раньше текущей даты, дата окончания не может быть раньше даты начала'
        });
        return false;
      }

      return true;
    },
    dateValidate(): boolean {
      return eventId
          ? moment(this.event.tsStart).isBefore(this.event.tsEnd)
          : moment(Date.now()).isBefore(this.event.tsStart) && moment(this.event.tsStart).isBefore(this.event.tsEnd);
    },
    saveDate(e: any, key: keyof EventType) {
      if (this.categories.length && this.cameras.length) {
        this.isShowConfirm.text = 'изменение времени и даты';
        this.isShowConfirm.action = () => {
          (this.event as any)[key] = e;
          this.isShowConfirm.show = false;
          return null;
        };
        this.isShowConfirm.actionData = null;
        this.isShowConfirm.show = true;
      } else {
        (this.event as any)[key] = e;
      }

      this.eventStartError = !this.validate() && key == 'tsStart';
      this.eventEndError = !this.validate() && key == 'tsEnd';
    },
    async save() {
      if (this.validate()) {
        if (!this.event.initiator) {
          this.event.initiator = {id: this.$store.state.user.initiatorId} as InitiatorClass;
        }
        this.disableSave = true;
        try {
          await EventApi.save(this.event);
          this.$store.commit('setMessage', {show: true, text: 'Мероприятие сохранено'});
          eventId = this.event.id;
          await this.$router.push({name: RoutsData.EVENT_SHOW_ROOT.name, params: {eventId: this.event.id.toString()}});
          this.getEvent(this.event.id);
        } catch (e) {
          this.$store.commit('setMessage', {show: true, text: 'Произошла ошибка'});
        } finally {
          this.disableSave = false;
        }
      }
    },
    edit() {
      if (this.validate()) {
        EventApi.edit(this.event.id, this.event).then((res: any) => {
        });
      }
    },
    getCamera(id: string) {
      CameraApi.getListByEvent(id).then(res => {
        this.cameras = res.data;
      });
    },
    addCamera() {
      const camera = new Camera(this.event.id, 'Локация №' + (this.cameras.length + 1));
      if (this.channel.length > 0) {
        camera.channel = this.channel[0];
      }
      this.cameras.push(camera);
      this.saveCamera();
    },
    showConfirm(data: { text: string, action: any, actionData: any }) {
      this.isShowConfirm.text = data.text;
      this.isShowConfirm.action = data.action;
      this.isShowConfirm.actionData = data.actionData;
      this.isShowConfirm.show = true;
    },
    deleteCamera(ind: number) {
      this.isShowConfirm.show = false;
      const filterCategory = this.categories.filter(cat => cat.cameraToTicketCategory && cat.cameraToTicketCategory.some(val => val.cameraId == this.cameras[ind].id));
      if (filterCategory.length) {
        this.$store.commit('setMessage', {
          show: true,
          timeout: 1000000,
          text:
              'Невозможно удалить локацию, так как она указана в категории билетов: '
              + filterCategory.map(i => i.title).toString() +
              '. Для удаления данной локации необходимо изменить категорию.'
        });
        return;
      }
      const camera = this.cameras.splice(ind, 1);
      CameraApi.delete(camera[0].id);
    },
    saveCamera() {
      CameraApi.save(this.cameras[this.cameras.length - 1]);
    },
    editCamera(index: number) {
      CameraApi.edit(this.cameras[index].id, this.cameras[index]);
    },
    onCategoryChange(e: TicketCategory[]) {
      this.categories = e;
    },
    getChannel() {
      ChannelApi.getList().then(res => {
        this.channel = res.data;
      });
    }
  }
});
